// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_policy_search.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { PasswordPolicy } from "./password_push_flow";
// ====== Messages ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyRef
 */
export interface PasswordPolicyRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
// ====== Search ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicySearchServiceSearchRequest
 */
export interface PasswordPolicySearchServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPolicyRef refs = 3;
     */
    refs: PasswordPolicyRef[];
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicySearchServiceSearchResponse
 */
export interface PasswordPolicySearchServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPolicy list = 1;
     */
    list: PasswordPolicy[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyRef$Type extends MessageType<PasswordPolicyRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyRef
 */
export const PasswordPolicyRef = new PasswordPolicyRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicySearchServiceSearchRequest$Type extends MessageType<PasswordPolicySearchServiceSearchRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicySearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicySearchServiceSearchRequest
 */
export const PasswordPolicySearchServiceSearchRequest = new PasswordPolicySearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicySearchServiceSearchResponse$Type extends MessageType<PasswordPolicySearchServiceSearchResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicySearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPolicy },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicySearchServiceSearchResponse
 */
export const PasswordPolicySearchServiceSearchResponse = new PasswordPolicySearchServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPolicySearchService
 */
export const PasswordPolicySearchService = new ServiceType("c1.api.password_push.v1.PasswordPolicySearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPolicySearchServiceSearchRequest, O: PasswordPolicySearchServiceSearchResponse }
]);
